import { Button, Dropdown, DropdownButton, Form, Modal } from 'react-bootstrap'
import { shuffleArray, ungroupCard } from '../../Commons/Functions'
import { SECTIONS } from '../PlayerSection/PlayerSection'
import { v4 as uuidv4 } from 'uuid';
import { ACTION_MODES } from '../ActionMode';
import { use, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import CustomDropdownButton, { CustomDropdownMenu } from '../GameElements/CustomDropdownButton';
import { RightClickMenu } from '../../Commons/RightClickMenuArea';

export default function CardQuickActions(props) {
    const [showNotesModal, setShowNotesModal] = useState(false)
    const [showXFromTopModal, setShowXFromTopModal] = useState(false)

    function close() {
        setShowNotesModal(false)
        setShowXFromTopModal(false)
        props.setIsTextInputFocused(false)
        props.onClose()
    }

    function sendToDeckTop(pos = 0) {
        if (!props.deck.current) { return }
        const insertionIndex = Math.max(0, Math.min(props.deck.current.length, pos));
        let c = { ...props.cards.splice(props.index, 1)[0] }
        ungroupCard(c, props.cards)
        c.counters = [{}, {}]
        props.deck.current.splice(props.deck.current.length - insertionIndex, 0, c)
        props.repositionCards()

        if (insertionIndex === 0) {
            props.sendToHistory("put at the top of their deck", props.card)
        } else {
            props.sendToHistory(`put into their deck ${insertionIndex + 1} from top`, props.card)
        }
        close()
    }

    function sendToDeckBottom() {
        if (!props.deck.current) { return }
        let c = { ...props.cards.splice(props.index, 1)[0] }
        ungroupCard(c, props.cards)
        c.counters = [{}, {}]
        props.deck.current.unshift(c)
        props.repositionCards()
        props.sendToHistory("put at the bottom of their deck", props.card)
        close()
    }

    function shuffleIntoDeck() {
        if (!props.deck.current) { return }
        let c = { ...props.cards.splice(props.index, 1)[0] }
        ungroupCard(c, props.cards)
        c.counters = [{}, {}]
        props.deck.current.push(c)
        shuffleArray(props.deck.current)
        props.repositionCards()
        props.sendToHistory("deck has been shuffled", props.card)
        close()
    }

    function flip() {
        const c = props.cards[props.index]
        const isFlipped = !c.isFlipped

        c.isFlipped = isFlipped
        props.cards[props.index].isHorizontal = isFlipped ? c.cardData.face.back.isHorizontal : c.cardData.face.front.isHorizontal

        props.moveCard(c, c.position.section)
        props.repositionCards()
    }

    function hide(val) {
        if (val == "yes") {
            [...props.opponentIds, props.playerId].forEach(id => {
                props.card.hiddenTo[id] = true
            })
            props.sendToHistory("hid a card")
        } else if (val == "opponent-only") {
            props.card.hiddenTo = {}
            props.opponentIds.forEach(id => {
                props.card.hiddenTo[id] = true
            })
            props.sendToHistory("hid a card from other players")
        } else if (val == "no") {
            props.card.hiddenTo = {}
            props.sendToHistory("revealed", props.card)
        } else {
            if (props.card.hiddenTo[val]) {
                delete props.card.hiddenTo[val]
                props.sendToHistory("hid a card from one player", props.card)
            } else {
                props.card.hiddenTo[val] = true
                props.sendToHistory("revealed a card to one player", props.card)
            }
        }
        props.moveCard(props.card, props.card.position.section)
        props.repositionCards()
    }

    function group() {
        props.setCurrentActionMode({
            ...props.currentActionMode,
            action: ACTION_MODES.GROUP,
            actionData: {
                cardToGroupIndex: props.index,
                cardName: props.cards[props.index].cardData.name
            }
        })
        close()
    }

    function ungroup() {
        let parentSection = SECTIONS.DISCARD
        let index = props.cards.findIndex((a) => a.id === props.card.grouppedToId)
        let parent = index >= 0 ? props.cards[index] : false
        if (parent) {
            parentSection = parent.position.section
        }

        ungroupCard(props.card, props.cards)
        props.card.position.section = parentSection
        console.log(parentSection)
        props.card.position.index = 9999
        props.repositionCards()
        close()
    }

    function toggleCounter(index) {
        if (props.card.counters[index].value !== undefined) {
            props.card.counters[index] = {}
        } else {
            props.card.counters[index] = {
                value: 0
            }
        }
        props.repositionCards()
    }

    function toggleNoUntap() {
        if (props.card.noUntap === undefined) {
            props.card.noUntap = true
        } else {
            delete props.card.noUntap
        }
        props.repositionCards()
        close()
    }

    function moveToSection(section, rank = null) {
        let c = props.cards[props.index]
        props.moveCard(c, section)
        if (rank === "shuffle") {
            props.cards.forEach((ca) => {
                if (ca.position.section === section) {
                    ca.position.index = Math.floor(Math.random() * 101) - 101
                }
            })
            props.sendToHistory(`Shuffled into ${section}`, c)
        } else if (rank !== null) {
            c.position.index = rank
            props.sendToHistory(`Send to ${section} bottom`, c)
        } else {
            props.sendToHistory(`Send to ${section} top`, c)
        }
        props.repositionCards()
        close()
    }

    function duplicate() {
        let c = JSON.parse(JSON.stringify(props.cards[props.index]))
        c.id = uuidv4()
        c.isToken = true
        c.tokenCount = 1
        if (c.grouppedToId) {
            let index = props.cards.findIndex((a) => a.id === c.grouppedToId)
            if (index >= 0) {
                c.position.section = props.cards[index].position.section
                c.position.index = 9999
            }
        }
        delete c.grouppedToId
        delete c.grouppedCards
        props.cards.push(c)
        props.repositionCards()
        close()
    }

    return (
        <RightClickMenu position={props.position} show={props.show} close={close} additionalOutsideClickCondition={[showNotesModal, showXFromTopModal]}>
            {!props.card.isToken && props.card.owner === props.playerId && (
                <CustomDropdownButton drop={props.card.position.section == SECTIONS.STACK ? "start" : "end"} title="To deck" className="w-100">
                    <Dropdown.Item href="" onClick={() => sendToDeckTop()}>Top</Dropdown.Item>
                    <Dropdown.Item href="" onClick={() => { setShowXFromTopModal(true); props.setIsTextInputFocused(true) }}>X from top</Dropdown.Item>
                    <Dropdown.Item href="" onClick={() => sendToDeckBottom()}>Bottom</Dropdown.Item>
                    <Dropdown.Item href="" onClick={() => shuffleIntoDeck()}>Shuffle</Dropdown.Item>
                </CustomDropdownButton>)}
            {props.extraDecks && props.extraDecks.map((d, i) => {
                return (
                    <CustomDropdownButton key={i} drop={props.card.position.section == SECTIONS.STACK ? "start" : "end"} title={`To ${d.displayTitle}`} className="w-100">
                        <Dropdown.Item href="" onClick={() => moveToSection(d.title)}>Top</Dropdown.Item>
                        <Dropdown.Item href="" onClick={() => moveToSection(d.title, 1000)}>Bottom</Dropdown.Item>
                        <Dropdown.Item href="" onClick={() => moveToSection(d.title, "shuffle")}>Shuffle</Dropdown.Item>
                    </CustomDropdownButton>
                )
            })}
            <Dropdown.Item href="" onClick={() => moveToSection(SECTIONS.EXILE)}>Remove</Dropdown.Item>
            <Dropdown.Item href="" onClick={() => moveToSection(SECTIONS.EXILE_HIDDEN)}>Remove hidden</Dropdown.Item>
            <Dropdown.Divider />
            {props.card.cardData.face.back && (<Dropdown.Item href="" onClick={() => flip()}>Flip</Dropdown.Item>)}
            <CustomDropdownButton drop={props.card.position.section == SECTIONS.STACK ? "start" : "end"} title="Visible by" className="submenu w-100">
                <Dropdown.Item href="" onClick={() => hide("no")}>All</Dropdown.Item>
                <Dropdown.Item href="" onClick={() => hide("yes")}>No one (faced down) </Dropdown.Item>
                <Dropdown.Item href="" onClick={() => hide("opponent-only")}>Only you</Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item className={!props.card.hiddenTo[props.playerId] ? "selected" : ""} href="" onClick={() => hide(props.playerId)}>You</Dropdown.Item>
                {props.opponentIds.map((o, i) => {
                    if (props.opponentsData && props.opponentsData[o]) {
                        return (<Dropdown.Item className={!props.card.hiddenTo[o] ? "selected" : ""} key={o} onClick={() => hide(o)}>{props.opponentsData[o].profileData.name}</Dropdown.Item>)
                    }
                })}
            </CustomDropdownButton>
            {!props.card.grouppedCards && (<Dropdown.Item href="" onClick={() => group()}>Group</Dropdown.Item>)}
            {props.card.grouppedToId && (<Dropdown.Item href="" onClick={() => ungroup()}>Ungroup</Dropdown.Item>)}
            <Dropdown.Item href="" onClick={() => duplicate()}>Duplicate</Dropdown.Item>
            {props.card.tokens && (
                <CustomDropdownButton drop={props.card.position.section == SECTIONS.STACK ? "start" : "end"} title="Create token" className="submenu w-100">
                    {props.card.tokens.map((t, i) => {
                        return (<Dropdown.Item key={t} onClick={() => {
                            props.createToken(t)
                        }}>{t.name}</Dropdown.Item>)
                    })}
                </CustomDropdownButton>
            )}
            <Dropdown.Divider />
            <CustomDropdownButton drop={props.card.position.section == SECTIONS.STACK ? "start" : "end"} title="Give to player" className="submenu w-100">
                {props.opponentIds.map((o, i) => {
                    if (props.opponentsData && props.opponentsData[o]) {
                        return (<Dropdown.Item key={o} onClick={() => {
                            ungroupCard(props.card, props.cards)
                            props.giveCardAtIndexTo(props.index, o)
                        }}>{props.opponentsData[o].profileData.name}</Dropdown.Item>)
                    }
                })}
            </CustomDropdownButton>
            <Dropdown.Divider />
            <Dropdown.Item className={props.card.noUntap === undefined ? "" : " selected"} onClick={() => toggleNoUntap()}>Doesn't untap</Dropdown.Item>
            {props.card.counters && (<Dropdown.Item className={props.card.counters[0].value === undefined ? "" : " selected"} onClick={() => toggleCounter(0)}>Toggle counter 1</Dropdown.Item>)}
            {props.card.counters && (<Dropdown.Item className={props.card.counters[1].value === undefined ? "" : " selected"} onClick={() => toggleCounter(1)}>Toggle counter 2</Dropdown.Item>)}
            <Dropdown.Item href="" onClick={() => { setShowNotesModal(true); props.setIsTextInputFocused(true) }}>Edit notes</Dropdown.Item>

            <EditCardNotesModal
                card={props.card}
                show={showNotesModal}
                handleClose={() => {
                    setShowNotesModal(false);
                    props.setIsTextInputFocused(false);
                    close();
                }}
                repositionCards={() => { props.repositionCards(); close(); }}
            />
            <XFromTopModal
                show={showXFromTopModal}
                handleClose={() => {
                    setShowXFromTopModal(false);
                    props.setIsTextInputFocused(false);
                    close();
                }}
                deck={props.deck.current}
                sendToDeckTop={sendToDeckTop}
            />

        </RightClickMenu>
    );
}

function EditCardNotesModal(props) {
    const [notes, setNotes] = useState("")
    return (
        <Modal className="" onEnter={() => setNotes(props.card.notes)} show={props.show} onHide={props.handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit notes</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <Form.Control
                    className="text-start position-relative"
                    as="textarea"
                    placeholder="Notes..."
                    autoFocus
                    defaultValue={notes}
                    rows={3}
                    onChange={(e) => {
                        setNotes(e.currentTarget.value)
                    }}
                    style={{ resize: "none" }}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" className="me-auto" onClick={() => {
                    setNotes("")
                    props.card.notes = ""
                    props.handleClose()
                    props.repositionCards()
                }}>
                    Delete
                </Button>
                <Button variant="secondary" onClick={() => {
                    props.handleClose()
                }}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={() => {
                    props.card.notes = notes
                    props.repositionCards()
                    props.handleClose()
                }}>
                    Confirm
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

function XFromTopModal(props) {
    const [x, setX] = useState(1)
    return (
        <Modal className="" onEnter={() => setX(1)} show={props.show} onHide={props.handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>X from top</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <p>Send the card to {x === 1 ? "the top of your deck" : `your deck at a position of ${x} from top`}.</p>
                <Form.Control
                    className="text-start position-relative"
                    type="number"
                    placeholder="1"
                    id="x-from-top-input"
                    autoFocus
                    value={x}
                    onChange={(e) => {
                        setX(Math.max(1, Math.min(props.deck.length + 1, e.currentTarget.value)))
                    }}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    props.handleClose()
                }}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={() => {
                    props.handleClose()
                    props.sendToDeckTop(x - 1)
                }}>
                    {x === 1 ? `Confirm top of the deck` : `Confirm ${x} from top`}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}